export const fields = [
  // STEM fields (sorted alphabetically)
  { value: "aerospace_engineering", label: "Aerospace Engineering", labelZh: "航空航天工程", isStem: true },
  { value: "artificial_intelligence", label: "Artificial Intelligence / Machine Learning", labelZh: "人工智能/机器学习", isStem: true },
  { value: "biology", label: "Biology", labelZh: "生物学", isStem: true },
  { value: "biomedical_engineering", label: "Biomedical Engineering", labelZh: "生物医学工程", isStem: true },
  { value: "biotechnology", label: "Biotechnology", labelZh: "生物技术", isStem: true },
  { value: "chemical_engineering", label: "Chemical Engineering", labelZh: "化学工程", isStem: true },
  { value: "chemistry", label: "Chemistry", labelZh: "化学", isStem: true },
  { value: "civil_engineering", label: "Civil Engineering", labelZh: "土木工程", isStem: true },
  { value: "computer_science", label: "Computer Science", labelZh: "计算机科学", isStem: true },
  { value: "cybersecurity", label: "Cybersecurity", labelZh: "网络安全", isStem: true },
  { value: "data_science", label: "Data Science", labelZh: "数据科学", isStem: true },
  { value: "electrical_engineering", label: "Electrical Engineering", labelZh: "电气工程", isStem: true },
  { value: "environmental_science", label: "Environmental Science", labelZh: "环境科学", isStem: true },
  { value: "information_technology", label: "Information Technology", labelZh: "信息技术", isStem: true },
  { value: "materials_science", label: "Materials Science", labelZh: "材料科学", isStem: true },
  { value: "mathematics", label: "Mathematics", labelZh: "数学", isStem: true },
  { value: "mechanical_engineering", label: "Mechanical Engineering", labelZh: "机械工程", isStem: true },
  { value: "physics", label: "Physics", labelZh: "物理学", isStem: true },
  { value: "statistics", label: "Statistics", labelZh: "统计学", isStem: true },

  // Non-STEM fields (sorted alphabetically)
  { value: "accounting", label: "Accounting", labelZh: "会计学", isStem: false },
  { value: "architecture", label: "Architecture", labelZh: "建筑学", isStem: false },
  { value: "business_administration", label: "Business Administration", labelZh: "工商管理", isStem: false },
  { value: "communications", label: "Communications", labelZh: "传播学", isStem: false },
  { value: "economics", label: "Economics", labelZh: "经济学", isStem: false },
  { value: "education", label: "Education", labelZh: "教育学", isStem: false },
  { value: "english_literature", label: "English / Literature", labelZh: "英语/文学", isStem: false },
  { value: "film_media", label: "Film / Media", labelZh: "电影/媒体", isStem: false },
  { value: "finance", label: "Finance", labelZh: "金融学", isStem: false },
  { value: "fine_arts", label: "Fine Arts", labelZh: "美术", isStem: false },
  { value: "history", label: "History", labelZh: "历史学", isStem: false },
  { value: "hospitality_management", label: "Hospitality Management", labelZh: "酒店管理", isStem: false },
  { value: "international_relations", label: "International Relations", labelZh: "国际关系", isStem: false },
  { value: "journalism", label: "Journalism", labelZh: "新闻学", isStem: false },
  { value: "law", label: "Law", labelZh: "法学", isStem: false },
  { value: "marketing", label: "Marketing", labelZh: "市场营销", isStem: false },
  { value: "music", label: "Music", labelZh: "音乐", isStem: false },
  { value: "philosophy", label: "Philosophy", labelZh: "哲学", isStem: false },
  { value: "political_science", label: "Political Science", labelZh: "政治学", isStem: false },
  { value: "psychology", label: "Psychology", labelZh: "心理学", isStem: false },
  { value: "public_health", label: "Public Health", labelZh: "公共卫生", isStem: false },
  { value: "public_policy", label: "Public Policy", labelZh: "公共政策", isStem: false },
  { value: "social_work", label: "Social Work", labelZh: "社会工作", isStem: false },
  { value: "sociology", label: "Sociology", labelZh: "社会学", isStem: false },
];
